import { Component, SimpleChanges, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ComponentModalBase } from '@framework/base/component';
import { ModalService, ToastService } from '@framework/services';
import { Store } from '@ngrx/store';
import { CoreState } from '@app/store/core/states';
import { Actions, ofType } from '@ngrx/effects';
import { SchedulerActions } from '@modules/company-admin/store/actions';
import { Subscription } from 'rxjs';
export interface StoryScheduleModalData {
  storyId: number;
  storyTitle: string;
  currentInternalStatus: boolean;
  currentPublicStatus: boolean;
  internalScheduledAt?: Date;
  publicScheduledAt?: Date;
  companyTimezone: string;
}

export interface StoryScheduleResult {
  storyId: number;
  internalScheduledAt?: Date;
  publicScheduledAt?: Date;
  internalScheduled: boolean;
  publicScheduled: boolean;
  selectedTimezone: string;
  scheduled_both: boolean;
}

export interface CalendarDate {
  day: number;
  date: Date;
  currentMonth: boolean;
  selected: boolean;
  today: boolean;
  disabled: boolean;
}

export interface TimezoneOption {
  value: string;
  label: string;
}

@Component({
  selector: 'app-story-schedule-modal',
  templateUrl: './story-schedule-modal.component.html',
  styleUrls: ['./story-schedule-modal.component.scss']
})
export class StoryScheduleModalComponent extends ComponentModalBase<any> implements OnInit, OnDestroy {

  public scheduleForm: UntypedFormGroup;
  public minDate: Date = new Date();
  public isSaving: boolean = false;
  public validationErrors: any = {};
  public is_both:boolean = false
  public internal_public_both: boolean = false;
  public payload:any;
  public is_new_schedule:any;
  // Modern UI properties
  public showDateTimePicker: boolean = false;
  public selectedDateTimeType: string = '';
  public currentPickerType: 'date' | 'time' = 'date';
  public currentScheduleType: 'internal' | 'public' | 'both' = 'internal';
  
  // Calendar properties
  public currentCalendarDate: Date = new Date();
  public calendarDates: CalendarDate[] = [];
  public weekdays: string[] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  
  // Time picker properties
  public popularTimes: string[] = ['9:00 AM', '11:00 AM', '12:00 PM', '2:30 PM', '5:30 PM'];
  public customHour: number = 9;
  public customMinute: number = 0;
  public customPeriod: string = 'AM';
  public userTimezone;

  loadSchedulerSuccessSubscription!: Subscription;
  loadSchedulerFailureSubscription!: Subscription;

  createSchedulerSuccessSubscription!: Subscription;
  createSchedulerFailureSubscription!: Subscription;

  updateSchedulerSuccessSubscription!: Subscription;
  updateSchedulerFailureSubscription!: Subscription;

  deleteSchedulerSuccessSubscription!: Subscription;
  deleteSchedulerFailureSubscription!: Subscription;

  // Timezone properties
  public availableTimezones: TimezoneOption[] = [
    { value: 'UTC', label: 'UTC (Coordinated Universal Time)' },
    { value: 'America/New_York', label: 'Eastern Time (US & Canada)' },
    { value: 'America/Chicago', label: 'Central Time (US & Canada)' },
    { value: 'America/Denver', label: 'Mountain Time (US & Canada)' },
    { value: 'America/Los_Angeles', label: 'Pacific Time (US & Canada)' },
    { value: 'America/Phoenix', label: 'Arizona Time' },
    { value: 'America/Anchorage', label: 'Alaska Time' },
    { value: 'Pacific/Honolulu', label: 'Hawaii Time' },
    { value: 'Europe/London', label: 'London (GMT/BST)' },
    { value: 'Europe/Paris', label: 'Central European Time' },
    { value: 'Europe/Berlin', label: 'Berlin Time' },
    { value: 'Europe/Rome', label: 'Rome Time' },
    { value: 'Europe/Madrid', label: 'Madrid Time' },
    { value: 'Asia/Tokyo', label: 'Japan Standard Time' },
    { value: 'Asia/Shanghai', label: 'China Standard Time' },
    { value: 'Asia/Kolkata', label: 'India Standard Time' },
    { value: 'Asia/Dubai', label: 'Gulf Standard Time' },
    { value: 'Australia/Sydney', label: 'Australian Eastern Time' },
    { value: 'Australia/Melbourne', label: 'Australian Eastern Time (Melbourne)' },
    { value: 'Australia/Perth', label: 'Australian Western Time' }
  ];

  constructor(
    private formBuilder: UntypedFormBuilder,
    private modalService: ModalService,
    private toastService: ToastService,
        private store$: Store<CoreState>,
        private actions$: Actions,
  ) {
    super();
    this.initForm();
  }

  // Life cycle hooks
  protected onInit(): void {
    // Initialize calendar on load
  this.userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  let obj = {
    label: this.userTimezone,
    value: this.userTimezone
  }
  this.availableTimezones.push(obj)
    this.generateCalendar();
    this.store$.dispatch(new SchedulerActions.GetScheduler(this.initialState.companyId,this.initialState.storyId));
    this.subscribe();
    if (this.initialState) {
      this.store$.dispatch(new SchedulerActions.GetScheduler(this.initialState.companyId,this.initialState.storyId));
      this.populateForm()
    }
    else{
      //to not populate
    }
  }

  protected onDestroy(): void {
    // Cleanup if needed;
    this.loadSchedulerSuccessSubscription.unsubscribe();
    this.loadSchedulerFailureSubscription.unsubscribe();
    
    this.createSchedulerSuccessSubscription.unsubscribe();
    this.createSchedulerFailureSubscription.unsubscribe();
    
    this.updateSchedulerSuccessSubscription.unsubscribe();
    this.updateSchedulerFailureSubscription.unsubscribe();
    
    this.deleteSchedulerSuccessSubscription.unsubscribe();
    this.deleteSchedulerFailureSubscription.unsubscribe();

  }

  protected onChanges(changes: SimpleChanges): void {}
  protected onDoCheck(): void {}
  protected onAfterContentInit(): void {}
  protected onAfterContentChecked(): void {}
  protected onAfterViewInit(): void {}
  protected onAfterViewChecked(): void {}

  public subscribe(){
// GET Scheduler Success
this.loadSchedulerSuccessSubscription = this.actions$.pipe(
  ofType<SchedulerActions.GetSchedulerSuccess>(SchedulerActions.ActionTypes.GET_SCHEDULER_SUCCESS)
).subscribe((action: SchedulerActions.GetSchedulerSuccess) => {
  //console.log('GET Scheduler Success:', action);
  this.is_new_schedule = false;
  this.is_both = action.payload[0].scheduled_both;

  let payload = action.payload;

  if(action.payload.length > 1){
    

    const filtered = action.payload.filter(item => !item.scheduled_both);

    if(filtered.length === 0){
      let payloadentries = payload.find(schedule => schedule.internal_scheduled_time);
      payloadentries.public_scheduled_time = (payload.find(schedule => schedule.public_scheduled_time)).public_scheduled_time;
      this.payload = payloadentries;
      let timezones = this.availableTimezones.find(item => item.label == this.payload.timezone);
  
      if(!timezones){
         let obj = {
           label: this.payload.timezone,
           value: this.payload.timezone
         }
         this.availableTimezones.push(obj)
      }
      this.scheduleForm.controls.selectedTimezone.setValue(this.payload.timezone)
      this.applyScheduleFromApi(payloadentries);
    }
    else{
      const combined = {
        internal_scheduled_time: null,
        public_scheduled_time: null,
        internal_only: false,
        public_only: false,
        spotlight_only: false, 
        campaign_only: false,
        scheduled_both:false,
        timezone:null
      };
    
      filtered.forEach(item => {
        if (item.internal_only && item.internal_scheduled_time) {
          combined.internal_scheduled_time = item.internal_scheduled_time;
          combined.internal_only = true;
        }
        if (item.public_only && item.public_scheduled_time) {
          combined.public_scheduled_time = item.public_scheduled_time;
          combined.public_only = true;
        }

        combined.spotlight_only = item.spotlight_only,
        combined.campaign_only = item.campaign_only,
        combined.scheduled_both = false
        combined.timezone = item.timezone
      });

      let timezones = this.availableTimezones.find(item => item.label == combined.timezone);
  
      if(!timezones){
         let obj = {
           label: combined.timezone,
           value: combined.timezone
         }
         this.availableTimezones.push(obj)
      }
      this.scheduleForm.controls.selectedTimezone.setValue(combined.timezone)
      this.applyScheduleFromApi(combined)
    }

  }
  else{
    this.payload = action.payload[0];

   let timezones = this.availableTimezones.find(item => item.label == this.payload.timezone);

   if(!timezones){
      let obj = {
        label: this.payload.timezone,
        value: this.payload.timezone
      }
      this.availableTimezones.push(obj)
   }
    this.scheduleForm.controls.selectedTimezone.setValue(this.payload.timezone)
    this.applyScheduleFromApi(action.payload[0]);
  }
 
  // this.scheduleForm.controls.bothEnabled.setValue(false);



});

// GET Scheduler Failure
this.loadSchedulerFailureSubscription = this.actions$.pipe(
  ofType<SchedulerActions.GetSchedulerFailure>(SchedulerActions.ActionTypes.GET_SCHEDULER_FAIL)
).subscribe((action: SchedulerActions.GetSchedulerFailure) => {
  this.is_new_schedule = true;
  let timezones = this.availableTimezones.find(item => item.label == this.userTimezone);

  if(!timezones){
     let obj = {
       label: this.userTimezone,
       value: this.userTimezone
     }
     this.availableTimezones.push(obj)
  }

  if(this.initialState.currentInternalStatus || this.initialState.currentPublicStatus){
    this.scheduleForm.controls.bothEnabled.setValue(false);
  }
  this.scheduleForm.controls.selectedTimezone.setValue(this.userTimezone);
});

// CREATE Scheduler Success
this.createSchedulerSuccessSubscription = this.actions$.pipe(
  ofType<SchedulerActions.CreateSchedulerSuccess>(SchedulerActions.ActionTypes.CREATE_SCHEDULER_SUCCESS)
).subscribe((action: SchedulerActions.CreateSchedulerSuccess) => {
  //console.log('CREATE Scheduler Success:', action);
});

// CREATE Scheduler Failure
this.createSchedulerFailureSubscription = this.actions$.pipe(
  ofType<SchedulerActions.CreateSchedulerFailure>(SchedulerActions.ActionTypes.CREATE_SCHEDULER_FAIL)
).subscribe((action: SchedulerActions.CreateSchedulerFailure) => {
  console.error('CREATE Scheduler Failure:', action);
});

// UPDATE Scheduler Success
this.updateSchedulerSuccessSubscription = this.actions$.pipe(
  ofType<SchedulerActions.UpdateSchedulerSuccess>(SchedulerActions.ActionTypes.UPDATE_SCHEDULER_SUCCESS)
).subscribe((action: SchedulerActions.UpdateSchedulerSuccess) => {
  //console.log('UPDATE Scheduler Success:', action);
});

// UPDATE Scheduler Failure
this.updateSchedulerFailureSubscription = this.actions$.pipe(
  ofType<SchedulerActions.UpdateSchedulerFailure>(SchedulerActions.ActionTypes.UPDATE_SCHEDULER_FAIL)
).subscribe((action: SchedulerActions.UpdateSchedulerFailure) => {
  console.error('UPDATE Scheduler Failure:', action);
});

// DELETE Scheduler Success
this.deleteSchedulerSuccessSubscription = this.actions$.pipe(
  ofType<SchedulerActions.DeleteSchedulerSuccess>(SchedulerActions.ActionTypes.DELETE_SCHEDULER_SUCCESS)
).subscribe((action: SchedulerActions.DeleteSchedulerSuccess) => {
  //console.log('DELETE Scheduler Success:', action);
});

// DELETE Scheduler Failure
this.deleteSchedulerFailureSubscription = this.actions$.pipe(
  ofType<SchedulerActions.DeleteSchedulerFailure>(SchedulerActions.ActionTypes.DELETE_SCHEDULER_FAIL)
).subscribe((action: SchedulerActions.DeleteSchedulerFailure) => {
  console.error('DELETE Scheduler Failure:', action);
});

  }


  private applyScheduleFromApi(payload: any): void {  
    if (payload?.scheduled_both) {
      // Case 1: BOTH

      const internlaScheduledAt = this.formatApiDateTime(payload?.internal_scheduled_time, payload?.timezone);
      const publicscheduledAt = this.formatApiDateTime(payload?.public_scheduled_time, payload?.timezone);

      if(!this.initialState.currentInternalStatus && !this.initialState.currentPublicStatus){
        this.scheduleForm.patchValue({
          bothEnabled: true,
          internalEnabled: false,
          publicEnabled: false,
          bothDate: internlaScheduledAt?.date || '',
          bothTime: internlaScheduledAt?.time || '',
          selectedTimezone: payload?.timezone || 'UTC'
        },{emitEvent: false});
      }

      else if (this.initialState.currentInternalStatus && !this.initialState.currentPublicStatus){
        this.scheduleForm.patchValue({
          bothEnabled: true,
          internalEnabled: false,
          publicEnabled: false,
          bothDate: publicscheduledAt?.date || '',
          bothTime: publicscheduledAt?.time || '',
          selectedTimezone: payload?.timezone || 'UTC'
        },{emitEvent: false});
      }
      else if (!this.initialState.currentInternalStatus && this.initialState.currentPublicStatus){
        this.scheduleForm.patchValue({
          bothEnabled: true,
          internalEnabled: false,
          publicEnabled: false,
          bothDate: publicscheduledAt?.date || '',
          bothTime: publicscheduledAt?.time || '',
          selectedTimezone: payload?.timezone || 'UTC'
        },{emitEvent: false});
      }
    } else {
      // Reset both OFF
      this.scheduleForm.patchValue({
        bothEnabled: false,
        bothDate: '',
        bothTime: '',
        selectedTimezone: payload?.timezone || 'UTC'
      }, {emitEvent: false});
  
      // Case 2: INTERNAL ONLY
      if (payload?.internal_only) {
        const internlaScheduledAt = this.formatApiDateTime(payload?.internal_scheduled_time, payload?.timezone);
        //console.log(internlaScheduledAt)
        this.scheduleForm.patchValue({
          internalEnabled: true,
          internalDate: internlaScheduledAt?.date || '',
          internalTime: internlaScheduledAt?.time || ''
        }, {emitEvent: false});
      }
  
      // Case 3: PUBLIC ONLY
      if (payload?.public_only) {
        const publicscheduledAt = this.formatApiDateTime(payload?.public_scheduled_time, payload?.timezone);
        this.scheduleForm.patchValue({
          publicEnabled: true,
          publicDate: publicscheduledAt?.date || '',
          publicTime: publicscheduledAt?.time || ''
        },{emitEvent: false});
      }
    }
  
    // Spotlight & Campaign flags
    this.scheduleForm.patchValue({
      spotlightOnly: payload?.spotlight_only || false,
      sendmail:payload.send_email,
      campaignOnly: payload?.campaign_only || false,
      selectedTimezone: payload?.timezone
    },{emitEvent: false});
  }
  

  // public formatApiDateTime(apiDate: string, timezone: string = 'UTC'): { date: string, time: string } {
  //   if (!apiDate) return { date: '', time: '' };
  
  //   // Convert string to Date
  //   const date = new Date(apiDate);
  
  //   // Format the date (YYYY-MM-DD)
  //   const formattedDate = date.toLocaleDateString('en-CA', { timeZone: timezone });
  
  //   // Format the time (24-hour HH:mm)
  //   const formattedTime = date.toLocaleTimeString('en-GB', {
  //     timeZone: timezone,
  //     hour: '2-digit',
  //     minute: '2-digit',
  //     hour12: false
  //   });
  
  //   return { date: formattedDate, time: formattedTime };
  // }

  public formatApiDateTime(apiDate: string, timezone = 'utc'): { date: string, time: string } {
    if (!apiDate) return { date: '', time: '' };
  
    // Split date and time parts
    const [datePart, rawTime] = apiDate.split('T');
  
    // Remove milliseconds + timezone (e.g., 14:30:00.000Z → 14:30:00)
    const timePart = rawTime.replace(/(\.\d+)?(Z|[+-]\d{2}:?\d{2})?$/, '');
  
    // Extract hours and minutes
    let [hours, minutes] = timePart.split(':');
  
    // Ensure 2-digit hours & minutes
    const formattedTime = `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
  
    return {
      date: datePart,   // YYYY-MM-DD
      time: formattedTime  // HH:mm (24-hour)
    };
  }
  
  
  
  
  
  // Private methods
  private initForm(): void {
    this.scheduleForm = this.formBuilder.group({
      bothEnabled: [true],      // Default to ON - "Internal and Public"
      bothDate: [''],
      bothTime: [''],
      internalEnabled: [false], // Always start OFF
      publicEnabled: [false],   // Always start OFF
      internalDate: [''],
      internalTime: [''],
      publicDate: [''],
      publicTime: [''],
      spotlightOnly: [false],
      sendmail:[false],
      campaignOnly: [false],
      selectedTimezone: ['UTC'] // Default to UTC
    });

    // Add validators when toggles are enabled
    this.scheduleForm.get('bothEnabled')?.valueChanges.subscribe(enabled => {
      const dateControl = this.scheduleForm.get('bothDate');
      const timeControl = this.scheduleForm.get('bothTime');

      if (enabled) {
        dateControl?.setValidators([Validators.required]);
        timeControl?.setValidators([Validators.required]);
        // Disable individual toggles when both is enabled
        this.scheduleForm.get('internalEnabled')?.setValue(false);
        this.scheduleForm.get('publicEnabled')?.setValue(false);
      } else {
        dateControl?.clearValidators();
        timeControl?.clearValidators();
        dateControl?.setValue('');
        timeControl?.setValue('');
      }
      dateControl?.updateValueAndValidity();
      timeControl?.updateValueAndValidity();
    });

    this.scheduleForm.get('internalEnabled')?.valueChanges.subscribe(enabled => {
      const dateControl = this.scheduleForm.get('internalDate');
      const timeControl = this.scheduleForm.get('internalTime');

      if (enabled) {
        dateControl?.setValidators([Validators.required]);
        timeControl?.setValidators([Validators.required]);
        // Disable both toggle when individual is enabled
        this.scheduleForm.get('bothEnabled')?.setValue(false);
      } else {
        dateControl?.clearValidators();
        timeControl?.clearValidators();
        dateControl?.setValue('');
        timeControl?.setValue('');
      }
      dateControl?.updateValueAndValidity();
      timeControl?.updateValueAndValidity();
    });

    this.scheduleForm.get('publicEnabled')?.valueChanges.subscribe(enabled => {
      const dateControl = this.scheduleForm.get('publicDate');
      const timeControl = this.scheduleForm.get('publicTime');

      if (enabled) {
        dateControl?.setValidators([Validators.required]);
        timeControl?.setValidators([Validators.required]);
        // Disable both toggle when individual is enabled
        this.scheduleForm.get('bothEnabled')?.setValue(false);
      } else {
        dateControl?.clearValidators();
        timeControl?.clearValidators();
        dateControl?.setValue('');
        timeControl?.setValue('');
      }
      dateControl?.updateValueAndValidity();
      timeControl?.updateValueAndValidity();
    });
  }

  private populateForm(): void {
    if (!this.initialState) return;

    // ALWAYS use defaults now - ignore localStorage for consistent behavior
    // This ensures "Internal and Public" is always ON by default
    //console.log('Using default settings: bothEnabled: true, others: false');
    
    // Clear any existing localStorage data for this story to prevent confusion
    const scheduleKey = `story_schedule_${this.initialState.storyId}`;
    localStorage.removeItem(scheduleKey);
    
    // Keep the form defaults (bothEnabled: true, others: false)
    // No need to call patchValue since initForm() already set the correct defaults
  }

  private formatDateForInput(date: Date): string {
    return date.toISOString().split('T')[0];
  }

  private formatTimeForInput(date: Date): string {
    return date.toTimeString().slice(0, 5);
  }

  private validateDateTime(dateStr: string, timeStr: string): Date | null {
    if (!dateStr || !timeStr) return null;

    const dateTime = new Date(`${dateStr}T${timeStr}`);
    const now = new Date();

    if (dateTime <= now) {
      return null; // Past date validation
    }

    return dateTime;
  }

  // Public methods
  public save(): void {
    if ((this.scheduleForm.invalid || this.isSaving) && !this.is_new_schedule) return;

    this.isSaving = true;
    this.validationErrors = {};

    const formValue = this.scheduleForm.value;
    let hasErrors = false;

    // Validate both scheduling (takes precedence)
    let internalScheduledAt: Date | undefined;
    let publicScheduledAt: Date | undefined;
    
    if(formValue.bothEnabled || formValue.publicEnabled || formValue.internalEnabled){
      if (formValue.bothEnabled) {
        const bothDateTime = this.validateDateTime(formValue.bothDate, formValue.bothTime);
        if (!bothDateTime) {
          this.validationErrors.both = 'Publish date must be in the future';
          this.toastService.error("Publish date must be in the future")
          
          hasErrors = true;
        } else {
          // Apply same date/time to both internal and public
          internalScheduledAt = bothDateTime;
          publicScheduledAt = bothDateTime;
        }
      } else {
        // Validate individual scheduling
        if (formValue.internalEnabled) {
          this.internal_public_both = false;
          internalScheduledAt = this.validateDateTime(formValue.internalDate, formValue.internalTime);
          if (!internalScheduledAt) {
            this.validationErrors.internal = 'Internal publish date must be in the future';
            this.toastService.error("Internal publish date must be in the future")
            hasErrors = true;
          }
        }
  
        if (formValue.publicEnabled) {
          publicScheduledAt = this.validateDateTime(formValue.publicDate, formValue.publicTime);
          if (!publicScheduledAt) {
            this.validationErrors.public = 'Public publish date must be in the future';
            this.toastService.error("Public publish date must be in the future")
            hasErrors = true;
          }
        }
  
        // Check if at least one schedule is set
        if (!formValue.internalEnabled && !formValue.publicEnabled) {
          this.validationErrors.general = 'Please enable at least one publishing schedule';
          this.toastService.error("Please enable at least one publishing schedule")
          hasErrors = true;
        }
      }
    }
    else{
      if(this.is_new_schedule){
        this.validationErrors.general = 'Please enable at least one publishing schedule';
        this.toastService.error("Please enable at least one publishing schedule")
        hasErrors = true;
        return
      }
    }


    


    if (hasErrors) {
      this.isSaving = false;
      return;
    }

    const result = {
      storyId: this.initialState!.storyId,
      internalScheduledAt,
      publicScheduledAt,
      internalScheduled: formValue.bothEnabled || formValue.internalEnabled,
      publicScheduled: formValue.bothEnabled || formValue.publicEnabled,
      selectedTimezone: formValue.selectedTimezone || 'UTC',
      scheduled_both:formValue.bothEnabled ? true : false,
      campaign_only:formValue.campaignOnly,
      spotlight_only:formValue.spotlightOnly,
      send_email:formValue.sendmail,
      is_guest:this.initialState.is_guest
    };

    // Save to localStorage for persistence
    const scheduleKey = `story_schedule_${this.initialState!.storyId}`;
    var scheduleData;

    scheduleData = {
      storyId: this.initialState.storyId,
      // internalScheduledAt: this.formatToLocalISO(internalScheduledAt),
      // publicScheduledAt:this.formatToLocalISO(internalScheduledAt),
      // savedAt: new Date().toISOString(),
      internalScheduled: formValue.bothEnabled || formValue.internalEnabled,
      publicScheduled: formValue.bothEnabled || formValue.publicEnabled,
      selectedTimezone: formValue.selectedTimezone || 'UTC',
      scheduled_both:formValue.bothEnabled ? true : false,
      campaign_only:formValue.campaignOnly,
      spotlight_only:formValue.spotlightOnly,
      is_guest:this.initialState.is_guest,
      admin_id:this.initialState.admin_id
    };

    if(this.is_new_schedule){
      if(internalScheduledAt){
        scheduleData.internalScheduledAt = this.formatToLocalISO(internalScheduledAt);;
      }
      if(publicScheduledAt){
      scheduleData.publicScheduledAt = this.formatToLocalISO(publicScheduledAt);
      }
     

    }
    if(!this.is_new_schedule){
      if(formValue.bothEnabled && !this.initialState.currentInternalStatus && !this.initialState.currentPublicStatus){
        scheduleData.internalScheduledAt = this.formatToLocalISO(internalScheduledAt);
        scheduleData.publicScheduledAt = this.formatToLocalISO(publicScheduledAt);
      }
      else if(formValue.bothEnabled && !this.initialState.currentInternalStatus && this.initialState.currentPublicStatus){
        scheduleData.internalScheduledAt = this.formatToLocalISO(internalScheduledAt);
        scheduleData.publicScheduledAt = '';
      }
      else if(formValue.bothEnabled && this.initialState.currentInternalStatus && !this.initialState.currentPublicStatus){
        scheduleData.internalScheduledAt = '';
        scheduleData.publicScheduledAt = this.formatToLocalISO(publicScheduledAt);
      }
      else{
        if(internalScheduledAt){
          scheduleData.internalScheduledAt = this.formatToLocalISO(internalScheduledAt);;
        }
        if (publicScheduledAt){
          scheduleData.publicScheduledAt =  this.formatToLocalISO(publicScheduledAt);
        }
      

      }

    }



    var scheduler_data = {

      scheduled_both:formValue.bothEnabled ? true : false,
      campaign_only:formValue.campaignOnly,
      spotlight_only:formValue.spotlightOnly,
      internal_only: formValue.bothEnabled || formValue.internalEnabled,
      public_only: formValue.bothEnabled || formValue.publicEnabled,
      storyId:this.initialState.storyId,
      public_scheduled_time:scheduleData.publicScheduledAt ? scheduleData.publicScheduledAt : null,
      internal_scheduled_time:scheduleData.internalScheduledAt ? scheduleData.internalScheduledAt : null
    }
    
    // localStorage.setItem(scheduleKey, JSON.stringify(scheduleData));
  //console.log('Saved schedule to localStorage:', scheduleData);
  if(!this.is_new_schedule){

    if(!formValue.bothEnabled && !formValue.publicEnabled && !formValue.internalEnabled ){
      this.store$.dispatch(new SchedulerActions.DeleteScheduler(this.initialState.companyId,this.initialState.storyId,));
      this.toastService.success('Task Cancelled');
      scheduler_data = null
    }
    else{
      this.store$.dispatch(new SchedulerActions.UpdateScheduler(this.initialState.companyId,this.initialState.storyId,scheduleData));
      this.toastService.success('Task Updated');
    }

  }
  else{
    this.store$.dispatch(new SchedulerActions.CreateScheduler(this.initialState.companyId,this.initialState.storyId,scheduleData));
    this.toastService.success('Task Created');
  }

    

    this.isSaving = false;
    this.onClose.emit(scheduler_data);
  }


  private formatToLocalISO(date: Date | undefined, offset = '+05:30'): string | undefined {
    if (!date) return '';

    const pad = (n: number) => n.toString().padStart(2, '0');
  
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
         + `T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}.000Z`;
  }
  public cancel(): void {
    this.onClose.emit(false);
  }

  public clearInternalSchedule(): void {
    this.scheduleForm.patchValue({
      internalEnabled: false,
      internalDate: '',
      internalTime: ''
    });
  }

  public clearPublicSchedule(): void {
    this.scheduleForm.patchValue({
      publicEnabled: false,
      publicDate: '',
      publicTime: ''
    });
  }

  // Toggle change handlers - just clear fields when turned off, don't close modal
  public onBothToggleChange(): void {
    const isEnabled = this.scheduleForm.get('bothEnabled')?.value;
    
    // If turning off, just clear the schedule fields
    if (!isEnabled) {
      this.clearBothSchedule();
    }
  }

  public onInternalToggleChange(): void {
    const isEnabled = this.scheduleForm.get('internalEnabled')?.value;
    
    // If turning off, just clear the schedule fields
    if (!isEnabled) {
      this.clearInternalSchedule();
    }
  }

  public onPublicToggleChange(): void {
    const isEnabled = this.scheduleForm.get('publicEnabled')?.value;
    
    // If turning off, just clear the schedule fields
    if (!isEnabled) {
      this.clearPublicSchedule();
    }
  }

  public clearBothSchedule(): void {
    this.scheduleForm.patchValue({
      bothEnabled: false,
      bothDate: '',
      bothTime: ''
    });
  }

  // Getters for template
  get storyTitle(): string {
    return this.initialState?.storyTitle || 'Story';
  }

  get companyTimezone(): string {
    return this.initialState?.companyTimezone || 'UTC';
  }

  get internalEnabled(): boolean {
    return this.scheduleForm.get('internalEnabled')?.value || false;
  }

  get publicEnabled(): boolean {
    return this.scheduleForm.get('publicEnabled')?.value || false;
  }

  get selectedTimezone(): string {
    return this.scheduleForm.get('selectedTimezone')?.value || 'UTC';
  }

  public formatDateDisplay(dateStr: string): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }

  // Modern UI Methods
  public openDateTimePicker(scheduleType: 'internal' | 'public' | 'both', pickerType: 'date' | 'time'): void {
    this.currentScheduleType = scheduleType;
    this.currentPickerType = pickerType;
    this.selectedDateTimeType = `${scheduleType}-${pickerType}`;
    this.showDateTimePicker = true;
    
    if (pickerType === 'date') {
      this.generateCalendar();
    }

    if (pickerType === 'time') {
     
  
      // Pre-fill modal with existing value if available
      const currentValue = this.scheduleForm.get(`${this.currentScheduleType}Time`)?.value;;
      if (currentValue) {
        const match = currentValue.match(/(\d+):(\d+)\s?(AM|PM)/i);
        if (match) {
          this.customHour = parseInt(match[1], 10);
          this.customMinute = parseInt(match[2], 10);
          this.customPeriod = match[3].toUpperCase();
        }
      }
      // Show modal (bootstrap/ngIf etc.)
    }
  }

  public closeDateTimePicker(): void {
    this.showDateTimePicker = false;
    this.selectedDateTimeType = '';
  }

  public applyDateTime(): void {
    this.closeDateTimePicker();
  }

  public hasActiveSchedule(): boolean {
    return this.scheduleForm.get('bothEnabled')?.value || this.scheduleForm.get('internalEnabled')?.value || this.scheduleForm.get('publicEnabled')?.value;
  }

  public hasValidScheduleData(): boolean {
    const bothEnabled = this.scheduleForm.get('bothEnabled')?.value;
    const internalEnabled = this.scheduleForm.get('internalEnabled')?.value;
    const publicEnabled = this.scheduleForm.get('publicEnabled')?.value;

    if (bothEnabled) {
      const bothDate = this.scheduleForm.get('bothDate')?.value;
      const bothTime = this.scheduleForm.get('bothTime')?.value;
      return !!(bothDate && bothTime);
    }

    if (internalEnabled) {
      const internalDate = this.scheduleForm.get('internalDate')?.value;
      const internalTime = this.scheduleForm.get('internalTime')?.value;
      if (!(internalDate && internalTime)) return false;
    }

    if (publicEnabled) {
      const publicDate = this.scheduleForm.get('publicDate')?.value;
      const publicTime = this.scheduleForm.get('publicTime')?.value;
      if (!(publicDate && publicTime)) return false;
    }

    return (internalEnabled || publicEnabled || bothEnabled);
  }

  public getFormattedDate(controlName: string): string {
    const dateValue = this.scheduleForm.get(controlName)?.value;
    if (!dateValue) return '';
    
    const [year, month, day] = dateValue.split('-').map(Number);
    const date = new Date(year, month - 1, day); // Local calendar date
    return date.toLocaleDateString('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  }

  public getScheduleSummary(type: 'internal' | 'public' | 'both'): string {
    const dateControl = this.scheduleForm.get(`${type}Date`);
    const timeControl = this.scheduleForm.get(`${type}Time`);
    
    if (!dateControl?.value || !timeControl?.value) return 'Not scheduled';
    
    const formattedDate = this.getFormattedDate(`${type}Date`);
    return `${formattedDate} at ${timeControl.value} (${this.companyTimezone})`;
  }

  // Calendar Methods
  public generateCalendar(): void {
    const year = this.currentCalendarDate.getFullYear();
    const month = this.currentCalendarDate.getMonth();
    
    const firstDay = new Date(year, month, 1);
    
    // Adjust to start from Monday - fix the calculation
    const dayOfWeek = (firstDay.getDay() + 6) % 7;
    
    this.calendarDates = [];
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    // Calculate the start date properly without mutating objects
    const startDate = new Date(year, month, 1 - dayOfWeek);
    
    for (let i = 0; i < 42; i++) {
      // Create each date independently to avoid mutation issues
      const currentDate = new Date(year, month, 1 - dayOfWeek + i);
      
      const isCurrentMonth = currentDate.getMonth() === month;
      const isToday = currentDate.getTime() === today.getTime();
      const isDisabled = currentDate < today;
      
      // Check if this date is selected - fix the comparison
      const selectedDateStr = this.scheduleForm.get(`${this.currentScheduleType}Date`)?.value;
      let isSelected = false;
      
      if (selectedDateStr) {
        // Create a proper date from the selected date string and compare properly
        const selectedDate = new Date(selectedDateStr + 'T00:00:00');
        const currentDateNormalized = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
        const selectedDateNormalized = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate());
        
        isSelected = currentDateNormalized.getTime() === selectedDateNormalized.getTime();
      }
      
      this.calendarDates.push({
        day: currentDate.getDate(),
        date: new Date(currentDate), // Create a fresh copy
        currentMonth: isCurrentMonth,
        selected: isSelected,
        today: isToday,
        disabled: isDisabled
      });
    }
  }

  public selectDate(dateObj: CalendarDate): void {
    if (dateObj.disabled) return;
    
    const dateStr = dateObj.date.toLocaleDateString('en-CA'); 
    this.scheduleForm.get(`${this.currentScheduleType}Date`)?.setValue(dateStr);
    this.generateCalendar(); // Refresh to show selection
  }

  public previousMonth(): void {
    this.currentCalendarDate.setMonth(this.currentCalendarDate.getMonth() - 1);
    this.generateCalendar();
  }

  public nextMonth(): void {
    this.currentCalendarDate.setMonth(this.currentCalendarDate.getMonth() + 1);
    this.generateCalendar();
  }

  public getMonthYearDisplay(): string {
    return this.currentCalendarDate.toLocaleDateString('en-US', {
      month: 'long',
      year: 'numeric'
    });
  }

  public getSelectedDateDisplay(): string {
    const selectedDate = this.scheduleForm.get(`${this.currentScheduleType}Date`)?.value;
    if (!selectedDate) return 'Select a date';
    
    const date = new Date(selectedDate);
    return date.toLocaleDateString('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  }

  // Time Picker Methods
  public selectTime(time: string): void {
    // Convert 12-hour format to 24-hour format for storage
    const time24 = this.convertTo24Hour(time);
    this.scheduleForm.get(`${this.currentScheduleType}Time`)?.setValue(time24);
  }

  public isTimeSelected(time: string): boolean {
    const currentTime = this.scheduleForm.get(`${this.currentScheduleType}Time`)?.value;
    if (!currentTime) return false;
    
    // Convert stored 24-hour time back to 12-hour for comparison
    const currentTime12 = this.convertTo12Hour(currentTime);
    return currentTime12 === time;
  }

  public updateCustomTime(): void {
    if (this.customHour !== null && this.customMinute !== null && this.customPeriod) {
      // Create 12-hour format string
      const time12 = `${this.customHour}:${this.customMinute.toString().padStart(2, '0')} ${this.customPeriod}`;
      // Convert to 24-hour format for storage
      const time24 = this.convertTo24Hour(time12);
      this.scheduleForm.get(`${this.currentScheduleType}Time`)?.setValue(time24);
    }
  }

  // Helper methods for time conversion
  private convertTo24Hour(time12: string): string {
    const [time, period] = time12.split(' ');
    const [hours, minutes] = time.split(':');
    let hour24 = parseInt(hours);

    if (period === 'AM' && hour24 === 12) {
      hour24 = 0;
    } else if (period === 'PM' && hour24 !== 12) {
      hour24 += 12;
    }

    return `${hour24.toString().padStart(2, '0')}:${minutes}`;
  }

  // private convertTo12Hour(time24: string): string {
  //   const [hours, minutes] = time24.split(':');
  //   let hour12 = parseInt(hours);
  //   const period = hour12 >= 12 ? 'PM' : 'AM';

  //   if (hour12 === 0) {
  //     hour12 = 12;
  //   } else if (hour12 > 12) {
  //     hour12 -= 12;
  //   }

  //   return `${hour12}:${minutes} ${period}`;
  // }


  private convertTo12Hour(time24: string): string {
    // Expecting time in "HH:mm" format
    const [hoursStr, minutesStr] = time24.split(':');
    let hours = parseInt(hoursStr, 10);
    const minutes = parseInt(minutesStr, 10);
  
    if (isNaN(hours) || isNaN(minutes)) return time24;
  
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    if (hours === 0) hours = 12;
  
    return `${hours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
  }
  
  // Get display time in 12-hour format
  public getDisplayTime(controlName: string): string {
    const time24 = this.scheduleForm.get(controlName)?.value;
    if (!time24) return 'Select time';
    
    return this.convertTo12Hour(time24);
  }

  // Helper methods to check if a schedule is set for the future
  public isInternalScheduled(): boolean {
    const enabled = this.scheduleForm.get('internalEnabled')?.value;
    const dateValue = this.scheduleForm.get('internalDate')?.value;
    const timeValue = this.scheduleForm.get('internalTime')?.value;
    
    if (!enabled || !dateValue || !timeValue) {
      return false;
    }
    
    const scheduledDateTime = new Date(`${dateValue}T${timeValue}`);
    const now = new Date();
    
    return scheduledDateTime > now;
  }

  public isPublicScheduled(): boolean {
    const enabled = this.scheduleForm.get('publicEnabled')?.value;
    const dateValue = this.scheduleForm.get('publicDate')?.value;
    const timeValue = this.scheduleForm.get('publicTime')?.value;
    
    if (!enabled || !dateValue || !timeValue) {
      return false;
    }
    
    const scheduledDateTime = new Date(`${dateValue}T${timeValue}`);
    const now = new Date();
    
    return scheduledDateTime > now;
  }
}
